import dayjs from 'dayjs';
import _ from 'lodash';
import React from 'react';
import { MODES_REGLEMENTS } from '@/constants';
import { ModeReglementContext } from '@/contexts';
import { useIndicateursData, useRecuStatsData } from '@/hooks/accueil';
import useIndicateursStore from '@/zustand/accueil/useIndicateursStore';
import TileChiffresJour from '../tiles/TileChiffresJour';

type TileChiffresJourContainerPropsType = {
  /** Force un refresh des données */
  forceRefresh?: boolean;
};

/**
 * Conteneur smart pour TileChiffresJour
 * Gère automatiquement la récupération des indicateurs et stats reçus
 * Calcule les flags pour les modes de paiement internet
 */
const TileChiffresJourContainer = ({ forceRefresh }: TileChiffresJourContainerPropsType) => {
  const { regieModesReglement } = React.useContext(ModeReglementContext);

  const {
    indicateurs,
    loading: loadingIndicateurs,
    refresh: refreshIndicateurs,
  } = useIndicateursData();
  const { recuStats, loading: loadingRecuStats, refresh: refreshRecuStats } = useRecuStatsData();

  // Calcul des flags pour les modes de règlement internet
  const hasPaiementInternet = React.useMemo(
    () => _.some(regieModesReglement, { code: MODES_REGLEMENTS.CARTE_BANCAIRE_INTERNET }),
    [regieModesReglement],
  );

  const hasPrelevementInternet = React.useMemo(
    () => _.some(regieModesReglement, { code: MODES_REGLEMENTS.PRELEVEMENT_INTERNET }),
    [regieModesReglement],
  );

  // Heure de dernière interrogation MFO (timestamp du dernier fetch API)
  const cacheTimestamp = useIndicateursStore((state) => state.cache.timestamp);
  const heureInterrogationMfo = cacheTimestamp ? dayjs(cacheTimestamp).format('HH[h]mm') : null;

  // Effet pour forcer le refresh quand demandé par le parent
  React.useEffect(() => {
    if (forceRefresh) {
      refreshIndicateurs();
      refreshRecuStats();
    }
  }, [forceRefresh, refreshIndicateurs, refreshRecuStats]);

  return (
    <TileChiffresJour
      indicateurs={indicateurs}
      recuStats={recuStats}
      hasPaiementInternet={hasPaiementInternet}
      hasPrelevementInternet={hasPrelevementInternet}
      heureInterrogationMfo={heureInterrogationMfo}
      loading={loadingIndicateurs || loadingRecuStats}
    />
  );
};

export default TileChiffresJourContainer;
